"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitPointTask = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var SubmitPointTask = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SubmitPointTask, _super);
    function SubmitPointTask() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '领取积分日常任务接口';
        _this.code = '101032';
        _this.desc = '领取积分日常任务接口';
        _this.requestParams = new point_1.SubmitPointTaskRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SubmitPointTask;
}(service_1.BaseService));
exports.SubmitPointTask = SubmitPointTask;
//# sourceMappingURL=submitPointTask.js.map